<template>
  <div v-if="active" class="guide-tour">
    <div class="guide-backdrop" :class="{ dim: !rect }" @click="finish"></div>

    <div
      v-if="rect"
      class="guide-ring"
      :style="{
        top: rect.top + 'px',
        left: rect.left + 'px',
        width: rect.width + 'px',
        height: rect.height + 'px',
      }"
    ></div>

    <div class="guide-pop card shadow" :style="popStyle">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start mb-1">
          <h6 class="fw-bold mb-0">{{ step.title }}</h6>
          <button
            type="button"
            class="btn-close"
            aria-label="بستن راهنما"
            @click="finish"
          ></button>
        </div>
        <p class="small mb-3">{{ step.text }}</p>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-secondary">{{ index + 1 }} از {{ steps.length }}</small>
          <button type="button" class="btn btn-primary btn-sm" @click="next">
            {{ isLast ? "باشه، متوجه شدم" : "بعدی" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hasSeenGuide, markGuideSeen } from "@/utils/guide";

export default {
  name: "GuideTour",
  props: {
    tourId: { type: String, required: true },
    // [{ target: "css selector", title, text }]
    steps: { type: Array, required: true },
    autoStart: { type: Boolean, default: true },
  },
  data() {
    return { active: false, index: 0, rect: null };
  },
  computed: {
    step() {
      return this.steps[this.index] || {};
    },
    isLast() {
      return this.index >= this.steps.length - 1;
    },
    popStyle() {
      const r = this.rect;
      if (!r) {
        return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
      }
      const spaceBelow = window.innerHeight - (r.top + r.height);
      const top = spaceBelow > 230 ? r.top + r.height + 12 : Math.max(12, r.top - 236);
      let left = r.left + r.width / 2 - 160;
      left = Math.min(Math.max(12, left), window.innerWidth - 332);
      return { top: top + "px", left: left + "px" };
    },
  },
  methods: {
    start() {
      if (!this.steps.length) return;
      this.index = 0;
      this.active = true;
      this.$nextTick(this.locate);
      window.addEventListener("resize", this.locate);
      window.addEventListener("scroll", this.locate, true);
    },
    locate() {
      const s = this.steps[this.index];
      const el = s && s.target ? document.querySelector(s.target) : null;
      if (!el) {
        this.rect = null;
        return;
      }
      try {
        el.scrollIntoView({ block: "center", behavior: "smooth" });
      } catch (e) {
        /* noop */
      }
      const b = el.getBoundingClientRect();
      this.rect = {
        top: b.top - 4,
        left: b.left - 4,
        width: b.width + 8,
        height: b.height + 8,
      };
    },
    next() {
      if (this.isLast) {
        this.finish();
        return;
      }
      this.index += 1;
      this.$nextTick(this.locate);
    },
    finish() {
      this.active = false;
      markGuideSeen(this.tourId);
      window.removeEventListener("resize", this.locate);
      window.removeEventListener("scroll", this.locate, true);
    },
  },
  mounted() {
    if (this.autoStart && !hasSeenGuide(this.tourId)) {
      // کمی صبر تا محتوای صفحه رندر و داده‌ها بارگذاری شوند
      this._t = setTimeout(() => this.start(), 800);
    }
  },
  beforeUnmount() {
    clearTimeout(this._t);
    window.removeEventListener("resize", this.locate);
    window.removeEventListener("scroll", this.locate, true);
  },
};
</script>

<style scoped>
.guide-tour {
  position: fixed;
  inset: 0;
  z-index: 100050;
}
.guide-backdrop {
  position: absolute;
  inset: 0;
}
.guide-backdrop.dim {
  background: rgba(15, 18, 30, 0.55);
}
.guide-ring {
  position: absolute;
  border: 2px solid var(--bndbs-primary, #f35b21);
  border-radius: 8px;
  /* حفره‌ی نورانی: بیرون از قاب تیره می‌شود */
  box-shadow: 0 0 0 4px rgba(243, 91, 33, 0.25), 0 0 0 9999px rgba(15, 18, 30, 0.55);
  pointer-events: none;
  transition: top 0.2s ease, left 0.2s ease, width 0.2s ease, height 0.2s ease;
}
.guide-pop {
  position: absolute;
  width: 320px;
  max-width: calc(100vw - 24px);
  border: 0;
  border-radius: 12px;
}
</style>
